import { Component, OnInit, OnDestroy, ViewEncapsulation, Injector } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Ticket, TicketStatus, Product } from '../../../lib/lib';
import { StatusInfo } from '../../../lib/status-info';
import { DispatcherService } from '../../../services/dispatcher.service';
import { VuCommunicationService } from '../../../services/vu/vu-communication.service';
import { LoggingService } from '../../../services/logging/logging.service';
import { SaleService } from '../../../services/sale.service';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { LanguageService } from '../../../services/language.service';

@Component({
  moduleId: module.id,
  selector: 'ticket-info',
  templateUrl: './ticket-info.component.html',
  styleUrls: ['./ticket-info.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TicketInfoComponent implements OnInit, OnDestroy {
  private subscriptionTicket: Subscription;
  private dispatcherService: DispatcherService;
  private vuCommunicationService: VuCommunicationService;
  private log: LoggingService;
  private saleService: SaleService;
  protected configurationService: ConfigurationService;
  private languageService: LanguageService;
  ticket = new Ticket();
  product: Product = null;
  subProduct: Product = null;

  constructor(
    private injector: Injector,
  ) {
    this.log = this.injector.get(LoggingService);
    this.dispatcherService = this.injector.get(DispatcherService);
    this.vuCommunicationService = this.injector.get(VuCommunicationService);
    this.saleService = this.injector.get(SaleService);
    this.configurationService = this.injector.get(ConfigurationService);
    this.languageService = this.injector.get(LanguageService);
  }

  ngOnInit(): void {
    this.dispatcherService.pageHeaderSet('Ticket Information');
    this.subscriptionTicket = this.dispatcherService.onTicketChangedSubscribe(x => this.onTicketChanged(x));
  }

  ngOnDestroy() {
    this.dispatcherService.pageHeaderSet();
    this.subscriptionTicket.unsubscribe();
  }

  private onTicketChanged(ticket: Ticket): void {
    this.subProduct = null;
    this.ticket = ticket;
    if (!ticket.isUnknown) {
      this.updateProduct(ticket.productId);
    }
  };

  get statusInfo(): StatusInfo {
    let status = this.ticket == null ? TicketStatus.Unknown : this.ticket.status;
    return StatusInfo.getStyleByTicketStatus(status);
  }

  onPayClick() {
    if (this.subProduct == null) {
      return;
    }

    let ticket = this.ticket;
    if (ticket == null) {
      return;
    }

    let quantity = Math.floor(ticket.outstandingOvertime / this.subProduct.accessTimeMinutes) + 1;
    if (!quantity) {
      return;
    }
    let order = this.saleService.order;
    order.addProduct(this.subProduct, quantity);
    order.isPrefilledOrder = true;
    order.barcode = ticket.code;
    this.dispatcherService.ticketOvertimePayment();
  }

  get isRoleExit(): boolean {
    return this.configurationService.isRoleExit;
  }

  private updateProduct(productId: number) {
    if (productId == null || productId === 0) { return; }

    this.vuCommunicationService.vuHttp.getSubProduct(productId)
      .then(subProduct => {
        this.subProduct = subProduct;
        this.log.info(`TicketInfoComponent. subProduct: ${subProduct}`);
      });

    this.vuCommunicationService.vuHttp.getProduct(productId)
      .then(product => {
        this.product = product;
        this.log.info(`TicketInfoComponent. product: ${product}`);
      });
  }

  onTicketUseClick() {
    if (this.ticket != null) {
      this.dispatcherService.ticketUse(this.ticket);
    }
  }

  get isStaff() {
    return this.statusInfo.status === TicketStatus.Staff;
  }

  onReturnClick() {
    this.saleService.ticketReturnAmount(this.product, this.ticket.amount, this.ticket.orderId, this.ticket.code, false);
  }

  get language(): string {
    return this.languageService.odooLanguageName;
  }

  get productName(): string {
    return this.ticket.productFormattedName(this.language)
  }

  get viewQuantityInfo(): boolean {
    return !this.ticket.isUnknown && !this.isStaff && this.ticket.quantity != 0
  }

  get isTicketHistoryButtonVisible(): boolean {
    return !this.ticket.isUnknown && !this.ticket.isVirtualTicket
  }

  get isTicketValid() {
    return this.ticket.status === TicketStatus.Valid;
  }
}
